import axios from 'axios';
import {getApiConfig} from '../config/configProvider';
import {GQL_SUBSTITUTES} from '../gql/substitutes.gql';

export default class SubstitutesApi {
  static getSubstitutes(params, headers) {
    try {
      const config = getApiConfig();
      return axios({
        url: config.graphQL,
        method: 'post',
        data: {
          query: GQL_SUBSTITUTES,
          variables: params,
        },
        headers,
      }).then(res => res.data);
    } catch (e) {
      return [];
    }
  }
}
